<template>
  <v-btn
    :loading="loading"
    small
    color="warning"
    @click="syncUsers"
  >
    Sync with AD
  </v-btn>
</template>

<script>
import { mapState } from 'vuex';

import { namespace as AuthNamespace } from '@store/modules/auth.types';

import { wrapToLoadingFn } from '@helpers';

import UsersApiService from '../_services/users.api.service';

export default {
  name: 'UmsSyncAzureUsers',

  data() {
    return {
      loading: false,
    };
  },

  computed: {
    ...mapState(AuthNamespace, ['code']),
  },

  methods: {
    syncUsers() {
      this.wrapToLoadingFn({
        req: UsersApiService.syncUsersWithAD.bind({}, { authCode: this.code }),
        fullscreenLoadingSpinner: true,
        onSuccess: () => {
          this.$emit('refresh');
          this.$VBlackerTheme.notification.success('Successfully synced');
        },
      });
    },

    wrapToLoadingFn,
  },
};
</script>
